var request = require('./request');
var config = require('./config');
var resolve = require('./resolve');

exports.GetEvaluationReportLabels = function(applicationId) {
	return request.get(resolve(config.url(),'/evaluations/' + applicationId)).promise();
}

exports.GetEvaluationReportDetails = function(reportId) {
	return request.get(resolve(config.url(),'/evaluations/' + reportId + '/details')).promise();
}

exports.StartEvaluationReport = function(reportId) {
	return request.put(resolve(config.url(),'/evaluations/' + reportId + '/start')).promise();
}

exports.UpdateEvalutionReport = function(report){
  var update = {
    reportId: report.reportId,
    requiredDate: report.requiredDate,
    isStarted: report.isStarted,
    isComplete: report.isComplete,
    isDeleted: report.isDelete,
    objectiveMetEvidence: report.objectiveMetEvidence,
    directBenefitEvidence: report.directBenefitEvidence,
    indirectBenefitEvidence: report.indirectBenefitEvidence,
    relevantDonorFunderEvidence: report.relevantDonorFunderEvidence
  }
  return request.put(resolve(config.url(),'/evaluations/full'), update).promise();
}

exports.SubmitForApproval = function(reportId, tab){
  var report = {
    reportId: reportId,
    tab: tab
  }
  return request.put(resolve(config.url(),'/evaluations/submit'), report).promise();
}

exports.CancelSubmitForApproval = function(reportId, tab){
  var report = {
    reportId: reportId,
    tab: tab
  }
  return request.put(resolve(config.url(),'/evaluations/cancel'), report).promise();
}
exports.UpdateEvalutionReportBreakdownCost = function(costItem){
  var item = {
    breakdownCostId: costItem.id,
    comment: costItem.comment,
    actualCost: costItem.actualCost
  }
  return request.put(resolve(config.url(),'/evaluations/breakdown'), item).promise();
}
exports.AddReportDocument = function(upload){
  var document = {
        applicationEvaluationReportId: upload.applicationEvaluationReportId,        
        blobId: upload.blobId,
        fileName: upload.fileName,
        fileSize:upload.fileSize,
        isPublic: upload.isPublic,
        comment: upload.comment
      };
  return request.post(resolve(config.url(),'/evaluations/document'), document).promise();
}
exports.RemoveReportDocument = function(document){
  return request.del(resolve(config.url(),'/evaluations/document/' +  document.id)).promise();
}

